export default "__VITE_ASSET__DThslHuP__"